export default theme => {
  return {
    container: {
      height: '100%',
    },
    h0: {
      variant: 'subtitle1',
      height: '100%',
      backgroundColor: theme.palette.grey[200]
    },
    d0: {
      marginTop: 5,
      marginBottom: 5,
      paddingLeft: 5,
      paddingRight: 5
    },
    metricsValuesText: {
      padding: 2
    },
    stat: {
      marginRight: 5,
      marginLeft: 5,
      borderRadius: 8
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/InvestorServices/theme/components/scorecard/ScorecardView/ScorecardScroller/ScorecardScrollableColumn/ScorecardMetricsValues.js